/**
 * @generated SignedSource<<74a46e1fb4f57856184f83e6a4b77e9e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type contentReactionDisplayUpvote$data = {
  readonly updatedAt: number;
  readonly upvoted: boolean;
  readonly " $fragmentType": "contentReactionDisplayUpvote";
};
export type contentReactionDisplayUpvote$key = {
  readonly " $data"?: contentReactionDisplayUpvote$data;
  readonly " $fragmentSpreads": FragmentRefs<"contentReactionDisplayUpvote">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "contentReactionDisplayUpvote",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "upvoted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    }
  ],
  "type": "Upvote",
  "abstractKey": null
};

(node as any).hash = "48f8010b5d57c13bf204ffe0027f99e8";

export default node;
